module.exports = __webpack_public_path__ + "684bc3d24f1fe7ec72df4456ff812b5e.svg";